/* eslint-disable */
import { Record } from 'immutable'

export const AdminWelcomeEmailRecord = Record({
  text: null,
  description: null,
  quoteImage: null,
  quoteImageWidth: 450,
  subject: null,
})

export class AdminWelcomeEmail extends AdminWelcomeEmailRecord {
  constructor(props) {
    super(props)
  }
}
/* eslint-enable */
